var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.dropdown = {
	init: function () {
		site.dropdown.setHeight();
		$(window).resize(function() {
			site.dropdown.setHeight();
		});

		$('.boxText','.info').on('click', function(e) {
			e.stopPropagation();
		});

		$('.boxTitle a', '.info').attr('href', '#').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this),
				$body = $('body'),
				$box = $this.closest('.box');

			if (!$box.hasClass('open')) {
				$box.addClass('open');
				$body.addClass('dropdown-open');
			}
			else {
				site.dropdown.close();
			}
		});

		$('body').on('click', function () {
			if ($('body').is('.dropdown-open')) {
				site.dropdown.close();
			}
		});
	},

	setHeight:function() {
		var $dropdown = $('.boxText ul', '.info');
		$($dropdown).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	},

	close:function() {
		$('.box','.info').removeClass('open');
		setTimeout(function() {
			$('body').removeClass('dropdown-open');
		},400);
	}
};

site.facts = {
	init:function() {
		site.owl.init('#owl-facts', {
			loop: false,
			dots: true,
			responsive : {
				0: {
					items:1
				},
				768: {
					items:2
				},
				992: {
					items:3
				}
			}
		});
	}
};


site.frontpage = {
	init: function() {
		site.dropdown.init();
		site.frontpage.newsCarousel();
		$(window).resize(function() {
			site.frontpage.newsCarousel();
		});
		site.frontpage.mobileMenu();
	},

	hasCarousel: false,

	newsCarousel: function() {
		var $body = $('body');
		if ($body.width() < 768) {

			if (!site.frontpage.hasCarousel) {
				site.owl.init('.box_newsheadlines .items', {
					loop: true,
					mouseDrag: true,
					touchDrag: true,
					margin: 20,
					nav: true,
					navText: ["<div class=\"arrow\"><i class=\"fas fa-arrow-left\"></i></div>", "<div class=\"arrow\"><i class=\"fas fa-arrow-right\"></i></div>"],
					stopOnHover: true,
					navSpeed:1000,
					responsive: {
						0: {
							items: 1
						},
						600: {
							items: 2
						}
					}
				});
				site.frontpage.hasCarousel = true;
			}
		}
		else {
			if (site.frontpage.hasCarousel) {
				$('.box_newsheadlines .items').owlCarousel('destroy').removeClass('owl-carousel');
				site.frontpage.hasCarousel = false;
			}
		}
	},

	mobileMenu: function() {
		var $body = $('body');
		$('.level1 > a', '#mainmenu').on('click', function(e) {
			if ($body.width() < 991) {
				e.preventDefault();
				var $this = $(this);
				var className = $this.closest('li').attr('class').split(' ')[0];
				$('.' + className + ' > a', '#mMenu').trigger('click');
				$('#mainmenuToggle').trigger('click');
			}
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.belowContent = {
	responsive: function () {
		var $helpful = $('.belowContent');
		$helpful.responsiveDom({
			appendTo: '#contentContainer > .contentWrap',
			mediaQuery: 'screen and (max-width: 991px)',
		});
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});
	site.mMenu.init();
	site.accessibility.init();
	site.megamenu.init();
	site.svg.init();
	site.belowContent.responsive();
	site.labelFocus.init();
	site.facts.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
